import React from 'react';
import { cn } from '../../lib/utils';

export function AnimatedGradientText({ children, className }) {
  return (
    <span
      className={cn(
        'inline font-semibold bg-gradient-to-r from-[#ffaa40] via-[#9c40ff] to-[#ffaa40] bg-[length:300%_100%] bg-clip-text text-transparent animate-gradient',
        className
      )}
    >
      {children}
    </span>
  );
}
